module.exports = __webpack_public_path__ + "img/img20.2e9fac5e.svg";